<template>
    <v-layout>
        <v-btn ripple text class = 'mx-4' @click = 'getClients(); visibility = true;'>
            <v-icon left>add</v-icon>Добавить проект
        </v-btn>
		<dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
			<template v-slot:title>Создание проекта</template>
			<template v-slot:action>
				<v-btn 
					text 
					:disabled = '!valid'
					:loading = 'indicator'
					color='green darken-2' 
					@click = 'addProject'
				>
                    Создать
                </v-btn>
			</template>
			<template v-slot:content>
				<v-form v-model = 'valid' style = 'min-width: 320px; max-width: 420px;'>
                    <v-text-field v-model = "project.project_name" label="Название проекта" :rules = "[rules.required]"></v-text-field>
                    <v-textarea v-model = "project.desc" label="Описание проекта" :rules = "[rules.required]"></v-textarea>
                    <v-select
                        v-model = "project.segment_id" label="Сегмент" :rules = "[rules.required]" 
                        :items = "projectSegments"
                        item-value = 'segment_id' 
                    	item-text = 'segment_name'
					></v-select>
                    <v-select
                        v-model = "project.vertical_id" label="Вертикаль" :rules = "[rules.required]" 
                        :items = "projectVerticals"
                        item-value = 'vertical_id' 
                    	item-text = 'vertical_name' 
					></v-select>
                    <v-autocomplete 
						:loading = 'indicatorClients' 
						v-model = 'project.client_id' 
						:items = "clients" 
						item-text = "name" 
						item-value = "client_id" 
						label = "Клиент"
						:rules = "[rules.required]" 
					>
                        <template slot='no-data'>
                            <v-layout pa-2>
                                <span>Клиентов не найдено. Создайте нового клиента</span>
                            </v-layout>
                        </template>
                        <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
							<v-btn icon @click = 'createClient = true;'><v-icon>add</v-icon></v-btn>
                        </v-slide-x-reverse-transition>
                    </v-autocomplete>
                    <v-checkbox
		                hide-details
		                class = 'ma-0 pa-0'
		                v-model = "defineTableName"
		                label="Задать имя таблиц экспорта"
		            ></v-checkbox>
		            <v-text-field 
		                v-if = 'defineTableName' 
		                v-model = "project.project_table" 
		                label="Идентификатор таблицы" 
		                :rules = "[rules.safe]"
		            ></v-text-field>
                </v-form>
			</template>
		</dialog-fullscreen>
        <create-client :postAction = 'getClients' :initialState.sync = 'createClient'></create-client>
    </v-layout>
</template>
<script>
	import ClientCreate from '@/components/entities/clients/CreateDialog.vue'
	import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
	import projectHandlers from '@/mixins/project'
	
	export default {
	    name: 'ProjectCreateDialog',
	    components: {
			'create-client': ClientCreate,
			'dialog-fullscreen': DialogFullscreen
	    },
	    mixins: [projectHandlers],
	    data() {
	        return {
	            valid: false,
	            visibility: false,
	            createClient: false,
	            defineTableName: false,
	            indicator: false,
	            indicatorClients: false,
	            errorCreate: false,
				errorCreateMessage: '',
				lastCreated: null,
	            project: {},
	            client: {},
	            clients: [],
	            rules: {
	                required: value => !!value || 'Обязательное поле.',
	                safe: value => {
				    	const pattern = /^[a-z0-9_]*$/
				        return pattern.test(value) || 'Wrong format'
				    }
	            }
	        }
	    },
	    methods: {
	    	addProject() {
		        this.indicator = true;
		        this.createProjectPromise().then( (r) => {
		            let response = r.body;
		            if (response.result) {
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'project'
                            },
                            once: false
                        })
						this.indicator = false
						this.visibility = false
						this.lastCreated = response.data
						this.$store.dispatch('getObjects', this.navigateToProject)
		            } else {
		            	console.log(response)
		            }
		          })
			},
			navigateToProject() {
				this.$router.push({name: 'project', params: {project_id: this.lastCreated}})
			},
	        getClients() {
	        	this.indicatorClients = true;
	            this.$http.get(this.$store.getters.endpoint + '/db/clients', {
	                emulateJSON: true,
	                params: { 'login': this.$store.getters.currentUser.login },
	                headers: this.$store.state.restrictedHeaders
	            }).then((r) => {
	                let response = r.body;
	                if (response.result) {
	                	this.indicatorClients = false;
	                    this.clients = response.data
	                } else {
	                    console.log(response)
	                }
	            })
	        },
	        transliterate(text) {
	        	let ru = {
			        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 
			        'е': 'e', 'ё': 'e', 'ж': 'j', 'з': 'z', 'и': 'i', 
			        'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 
			        'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 
			        'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 
			        'щ': 'shch', 'ы': 'y', 'э': 'e', 'ю': 'u', 'я': 'ya'
			    }, n_str = [];
			    
			    text = text? text.replace(/[ъь]+/g, '').replace(/й/g, 'i'): '';
			    
			    for ( let i = 0; i < text.length; ++i ) {
			       n_str.push(
			              ru[ text[i] ]
			           || ru[ text[i].toLowerCase() ] == undefined && text[i]
			           || ru[ text[i].toLowerCase() ].replace(/^(.)/, function ( match ) { return match.toUpperCase() })
			       );
			    }
			    
			    return n_str.join('').replace(/[^A-Z0-9]+/ig, "_");
	        }
	    },
	    watch: {
	    	defineTableName(value) {
	    		if (value) {
	    			this.project.project_table = this.transliterate(this.project.project_name)
	    		}
			},
			visibility (value) {
				if (value) {
					this.$store.dispatch('fillSegments')
	    			this.$store.dispatch('fillVerticals')
				}
			}
	    },
	    computed: {
	    	projectSegments() {
	    		return this.$store.state.segments
	    	},
	    	projectVerticals() {
	    		return this.$store.state.verticals
	    	}
	    }
	}
</script>